import { getUserConfiguration } from 'owa-session-store';
import { getUserPermissionForFolderId, MenuItemType, doesUserHaveActionPermission } from '../index';

/**
 * This method restricts the movement of the items by drag and drop if user doesn't have enough permission for shared folder
 * @param sourceFolderId - source folder id
 * @param destinationFolderId - destination folder id
 */
export default function isSharedFolderItemMovementPermissible(
    sourceFolderId: string,
    destinationFolderId: string
) {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (16,23): Object is possibly 'undefined'.
    // @ts-expect-error
    const userEmail = getUserConfiguration().SessionSettings.UserEmailAddress;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2345 (20,89): Argument of type 'RecursiveReadOnly<string | undefined>' is not assignable to parameter of type 'string'.
    // @ts-expect-error
    const assignedSourceFolderPermission = getUserPermissionForFolderId(sourceFolderId, userEmail);
    const assignedDestinationFolderPermission = getUserPermissionForFolderId(
        destinationFolderId,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (26,9): Argument of type 'RecursiveReadOnly<string | undefined>' is not assignable to parameter of type 'string'.
        // @ts-expect-error
        userEmail
    );

    /**
     *  Check write permission for both source and destination folder
     */
    const doesUserHavePermission =
        doesUserHaveActionPermission(MenuItemType.Move, assignedSourceFolderPermission) &&
        doesUserHaveActionPermission(MenuItemType.Move, assignedDestinationFolderPermission);
    return doesUserHavePermission;
}
